import { gql } from '@apollo/client';

const FETCH_SENT_FAXES = gql`
  query FetchSentFaxes($limit: Int) {
    sent_faxes(limit: $limit) {
      id
      recipient
      fax_number
      message
      details
      attachment_names
      attachment_urls
      status
      status_label
      provider_fax_id
      sent_at
      completed_at
      created_at
    }
  }
`;

export { FETCH_SENT_FAXES };
